<template>
  <div class="ui-wrapper">
    <div class="decription-container">
      <h4>{{ $t('checkout.freeNumber.freeNumbers') }}</h4>
      <span>{{ $t('checkout.freeNumber.bodyText') }}</span>
    </div>
    <ec-carousel @swiper-change="onSlideChange"
                 :slide="slide"
                 :showArrows="showArrows"
                 :carouselOptions="sliderOptions">
      <ec-carousel-slide v-for="(slide, index) in slides"
                         :key="index">
        <div class="slide-item">
          <div v-for="(number, index) in numbers"
               :key="index"
               @click="addNum(number.number, index)"
               class="number-item"
               :class="{ selected: ++index === activeNumber }">
            <div class="number-container">
              <BaseRadio :checked="index === activeNumber"
                         :value="number.number"/>
              {{ number.number }}
            </div>
          </div>
        </div>
      </ec-carousel-slide>
    </ec-carousel>
    <div class="arrows-container">
      <span @click="prev"
            :class="{ disabled: !disablePrevBtn }"
            class="icon-arrow-left">
      </span>
      <span @click="next"
            :class="{ disabled: !disableNextBtn }"
            class="icon-arrow-right">
      </span>
    </div>
  </div>
</template>
<script>

import { getFreeNumbers } from '@/api/checkout'
import { EcCarousel, EcCarouselSlide } from '../../base/mini-carousel/'
import BaseRadio from '@/components/base/base-radio'

export default {
  name: 'NumberSlider',
  components: { EcCarousel, EcCarouselSlide, BaseRadio },
  props: {
    slides: Number,
    cartData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    numbersList: Array
  },
  data () {
    return {
      btnSlides: 5,
      mobileNumber: '',
      numbers: [],
      slide: 1,
      showArrows: true,
      disableNextBtn: true,
      disablePrevBtn: true,
      disableArrows: false,
      activeNumber: 0,
      activeSlider: 0,
      sliderOptions: Object.freeze({
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          768: {
            slidesPerView: 1
          },
          1366: {
            slidesPerView: 1
          }
        }
      })
    }
  },
  methods: {
    prev () {
      this.activeNumber = 0
      const query = {
        cartId: this.cartData.guid,
        page: --this.slide
      }
      this.getNumbers(query)
    },
    next () {
      this.activeNumber = 0
      const query = {
        cartId: this.cartData.guid,
        page: ++this.slide
      }
      this.getNumbers(query)
    },
    updateComponent (payload) {
      this.$emit('update-component', payload)
    },
    onSlideChange (i) {
      this.activeNumber = 0
      this.activeSlider = i
      this.slide = i
      const query = {
        cartId: this.cartData.guid,
        page: i
      }
      this.getNumbers(query)
    },
    selectNumber (num, i) {
      this.numbers.forEach((num, index) => {
        if (index === i - 1) {
          num.checked = !num.checked
        } else {
          num.checked = false
        }
      })
    },
    addNum (num, i) {
      this.selectNumber(num, i)
      this.mobileNumber = num
      this.$emit('phoneNumber', num)
      this.activeNumber = i
    },
    getNumbers (query) {
      getFreeNumbers(query).then(res => {
        this.disableNextBtn = res.data.msisdnList.pagination.hasNext
        this.disablePrevBtn = res.data.msisdnList.pagination.hasPrevious
        if (res.data.msisdnList.results.length) {
          this.numbers = res.data.msisdnList.results.map(num => {
            return {
              number: num.subscriberIdentity,
              checked: false
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.ui-wrapper {
  padding: 3.6rem 2.4rem;
  background-color: $white;
  position: relative;

  @media (map_get($breakpoints, sm)) {
    display: flex;
    padding: 2.8rem 1.4rem 0;
    flex-direction: column;
    border-radius: 5px;
  }

  @media (map_get($breakpoints, md)) {
    padding: 2.8rem 6.4rem 0;
  }

  h4 {
    color: $black;
    font-size: 20px;
  }
}

.decription-container {
  margin-bottom: 20px;
  @media (map_get($breakpoints, sm)) {
    padding: 0 57px;
  }
  @media (map_get($breakpoints, md)) {
    padding: 0 28px;
  }
}

.slide-item {
  height: 37vh;
  width: 100%;
  padding: 5px;
  display: flex;
  flex-direction: column;
  @media (map_get($breakpoints, sm)) {
    width: 100%;
    margin-top: 20px;
  }
  @media (map_get($breakpoints, sm)) {
    margin-left: 25px;
    flex-wrap: wrap;
    height: 20vh;
  }
}

.number-item {
  height: 6.3vh;
  border: solid 1px #bbb;
  border-radius: 6px;
  margin-bottom: 20px;
  @media (map_get($breakpoints, sm)) {
    width: 44%;
    :hover {
      cursor: pointer;
    }
  }
}

.selected {
  height: 6.3vh;
  margin-bottom: 20px;
  border: double 1px transparent;
  border-radius: 7px;
  z-index: 1;
  background-image: linear-gradient(white, white), radial-gradient(circle at top left, $dark-red, $warning);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.number-container {
  height: 4vh;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 0 10px 15px;

  width: 100%;
}

.disabled {
  pointer-events: none;
}

.arrows-container {
  display: none;
  @media (map_get($breakpoints, sm)) {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 92%;
    left: 24px;
    bottom: -50px;
    span {
      z-index: 2;
      @media (map_get($breakpoints, lg)) {
        &:hover {
          cursor: pointer;
        }
      }

      &::before {
        font-size: 30px;
        color: $primary;
      }
    }
  }
}
</style>
